export enum NpBookingStep {
  SELECT_PROVIDER = 'SELECT_PROVIDER',
  CLINICAL_INTAKE_CC = 'CLINICAL_INTAKE_CC',
  CLINICAL_INTAKE_BOOKING = 'CLINICAL_INTAKE_BOOKING',
  CLINICAL_INTAKE_PAYMENT = 'CLINICAL_INTAKE_PAYMENT',
  TESTING_SESSION_1_CC = 'TESTING_SESSION_1_CC',
  TESTING_SESSION_1_BOOKING = 'TESTING_SESSION_1_BOOKING',
  TESTING_SESSION_2_CC = 'TESTING_SESSION_2_CC',
  TESTING_SESSION_2_BOOKING = 'TESTING_SESSION_2_BOOKING',
  CONFIRMATION = 'CONFIRMATION',
}

export enum NpBookingExitVariant {
  STANDARD = 'STANDARD',
  TESTING_1 = 'TESTING_1',
  TESTING_2 = 'TESTING_2',
}

export enum NpBookingTitleId {
  SELECT_PROVIDER = 'SELECT_PROVIDER',
  APPOINTMENT_PROGRESS = 'APPOINTMENT_PROGRESS',
  APPOINTMENTS_BOOKED = 'APPOINTMENTS_BOOKED',
}

export enum NpBookingSubtitleId {
  CLINICAL_INTAKE = 'CLINICAL_INTAKE',
  TESTING_SESSION_1 = 'TESTING_SESSION_1',
  TESTING_SESSION_2 = 'TESTING_SESSION_2',
}

export type NpBookingStepMetadata = {
  appointmentNumber?: number
  titleId: NpBookingTitleId
  subtitleId?: NpBookingSubtitleId
  showBackButton: boolean
  exitModalVariant?: NpBookingExitVariant
}

export const NP_TOTAL_APPOINTMENTS = 3

/** Who the NP evaluation is being booked for: the member or one of their linked dependents */
export interface NpPatientBeingBookedFor {
  lyraId: string
  isDependent: boolean
  /** First name used in copy: the dependent's first name, or the member's preferred (else legal) first name */
  name: string
}
